import {
    getPost,
    getPage
} from '@/store/api/index'

import Breadcrumb from '@/components/Breadcrumb'
import Defaultpageheader from '@/components/layout/DefaultPageHeader'
import Textblock from '@/components/layout/TextBlock'
import Highlightblock from '@/components/layout/HighlightBlock'
import Imageblock from '@/components/layout/ImageBlock'
import Experiencelink from '@/components/layout/ExperienceLink'
import Contactlink from '@/components/layout/ContactLink'
import Contactblock from '@/components/layout/ContactBlock'
import Joinusblock from '@/components/layout/JoinusBlock'
import Joinuscta from '@/components/layout/JoinusCta'
import Videoblock from '@/components/layout/VideoBlock'
import Quote from '@/components/layout/Quote'
import Dualnavigation from '@/components/layout/DualNavigation/index'
import Relativeblock from '@/components/layout/RelativeBlock/index'
import Board from '@/components/layout/Board/index'
import Slider from '@/components/layout/Slider'
import Blog from '@/components/layout/Blog'
import Objectlist from '@/components/layout/ObjectList/index'
import Marketblock from '@/components/layout/MarketBlock/index'
import Textslider from '@/components/layout/TextSlider'
import Textlist from '@/components/layout/TextList'
import Keyfigure from '@/components/layout/Keyfigure'
import Practicallinks from '@/components/layout/PracticalLinks'
import Separatorwithimage from '@/components/layout/SeparatorWithImage'
import Promoblock from '@/components/layout/Promoblock'
import Mainhighlight from '@/components/layout/MainHighlight'
import Detailhighlight from '@/components/layout/DetailHighlight'
import Teamblock from '@/components/layout/TeamBlock'
import Historyblock from '@/components/layout/HistoryBlock'
import Links from '@/components/layout/Links/index'

import MainFooter from '@/components/MainFooter'
import Projectdetail from '@/views/Projects/ProjectDetail'

import {
    breadcrumb,
    seoMap
} from '@/store/index.js'
export default {
    components: {
        Breadcrumb,
        Defaultpageheader,
        Imageblock,
        Experiencelink,
        Contactlink,
        Contactblock,
        Joinusblock,
        Joinuscta,
        Videoblock,
        Textblock,
        Highlightblock,
        Quote,
        Dualnavigation,
        Relativeblock,
        Board,
        Slider,
        Blog,
        Objectlist,
        Marketblock,
        Textslider,
        Textlist,
        Keyfigure,
        Practicallinks,
        Separatorwithimage,
        Promoblock,
        Mainhighlight,
        Detailhighlight,
        Teamblock,
        Historyblock,
        Links,
        Projectdetail,
        MainFooter
    },
    data() {
        return {
            loading: true,
            page: undefined
        }
    },
    beforeDestroy() {
        breadcrumb.endRoute = null
    },
    methods: {
        getPost(payload) {
            breadcrumb.endRoute = null
            this.loading = true
            return getPost(payload)
                .then(res => {
                    if (!res) {
                        // throw new Error('No data')
                    }
                    this.loading = false
                    this.page = res
                    if (this.page) {
                        breadcrumb.endRoute = {
                            name: this.page.name || this.page.translated_title,
                            content: this.page.related_posts
                        }
                    }
                    if (this.page.customslug && this.$route.name !== 'Market') {
                        this.$router.replace({
                            params: {
                                slug: this.page.customslug
                            }
                        })
                    } else {
                        this.$nextTick(() => {
                          try { window.dispatchEvent(new Event('papillon')) } catch(e) {}
                        })
                    }
                    return res
                })
                .catch((err) => {
                    window.console.warn('PageNotFound', err)
                    this.$router.replace({
                        name: 'PageNotFound'
                    })
                })
        },
        getRevision() {
            breadcrumb.endRoute = null
            this.loading = true
            return getPost({
                    id: this.$route.query.preview_id,
                    type: 'revision',
                    locale: this.$route.params.locale
                })
                .then(res => {
                    if (!res) {
                        throw new Error('No data')
                    }
                    this.loading = false
                    this.page = res
                    breadcrumb.endRoute = {
                        name: this.page.name
                    }
                    this.$nextTick(() => {
                      try { window.dispatchEvent(new Event('papillon')) } catch(e) {}
                    })
                    return res
                })
                .catch((err) => {
                    window.console.warn('PageNotFound', err)
                    this.$router.replace({
                        name: 'PageNotFound'
                    })
                })

        },
        getPage(payload) {
            this.loading = true
            return getPage(payload)
                .then(res => {
                    if (!res) {
                        throw new Error('No data')
                    }
                    this.loading = false
                    this.page = res
                    this.$nextTick(() => {
                        try { window.dispatchEvent(new Event('papillon')) } catch(e) {}
                    })
                    return res
                })
                .catch((err) => {
                    window.console.warn('PageNotFound', err)
                    this.$router.replace({
                        name: 'PageNotFound'
                    })
                })
        },
        requestData(data) {
            const locale = this.$route.params.locale
            if (this.$route.meta.page) {
                return this.getPage({
                    locale,
                    id: this.$route.meta.page
                })
            } else {
                if (this.$route.query.preview_id) {
                    return this.getRevision()
                } else if (this.$route.meta.customPage) {
                    return this.getPost({
                        locale,
                        type: 'custom-page',
                        slug: this.$route.meta.customPage,
                        taxonomy: false
                    })
                } else if (this.$route.params.id || this.$route.params.slug) {
                    return this.getPost({
                        locale,
                        type: this.$route.meta.type,
                        slug: this.$route.params.slug,
                        id: this.$route.params.id,
                        taxonomy: data ? data.taxonomy : false
                    })
                }
            }
        }
    },
    metaInfo() {
        const {
            page,
            $route
        } = this
        return seoMap.build(page, page ? {
            seo_title: page.name || page.title,
            seo_description: page.context || page.baseline || page.description,
            seo_image: page.image,
            seo_url: process.env.VUE_APP_URL + this.$router.currentRoute.path,
        } : {}, $route)
    }
}